import { createContext, useContext, useSyncExternalStore } from "react";
import type { Api, Me } from "../lib/api.ts";
import { getLang, subscribeLang, t, type Key } from "../lib/i18n.ts";
import { errorMessage } from "../lib/i18n.ts";
import { ApiError } from "../lib/api.ts";

export interface AppCtx { api: Api; me: Me | null; setMe: (m: Me | null) => void; go: (path: string, replace?: boolean) => void; refreshMe: () => Promise<void> }
export const Ctx = createContext(null as unknown as AppCtx);
export const useApp = (): AppCtx => useContext(Ctx);
/** Subscribing to the language re-renders every component that calls this. */
export const useLang = (): string => useSyncExternalStore(subscribeLang, getLang);
export const msgOf = (e: unknown): string => e instanceof ApiError ? errorMessage(e.code, e.message) : t("err.generic");

export function Spinner() { return <span className="spinner" role="status" aria-label={t("loading")} />; }
export function Err({ children }: { children?: string | null }) {
  return children ? <div className="alert err" role="alert">{children}</div> : null;
}
export function Loading() { return <div className="empty"><Spinner /> <span className="muted">{t("loading")}</span></div>; }

export function Modal({ title, onClose, children }: { title: string; onClose: () => void; children: unknown }) {
  return (
    <div className="modal-bg" onMouseDown={(e: any) => { if (e.target === e.currentTarget) onClose(); }}
      onKeyDown={(e: any) => { if (e.key === "Escape") onClose(); }}>
      <div className="modal" role="dialog" aria-modal="true" aria-label={title}>
        <h2 style={{ fontSize: 16 }}>{title}</h2>
        {children}
      </div>
    </div>
  );
}
export const fmtDate = (sec: number): string => new Date(sec * 1000).toLocaleDateString(getLang(), { day: "numeric", month: "short", year: "numeric" });
export const k = (s: string): Key => s as Key;
